import { ListFilterDropdownElements } from '@components';
import { ColumnVisibilityLabels, ColumnVisibilityValues } from '@enums';
import { STORAGE_KEYS } from '@utils';

export const useBuildDefaultColumnVisibility = (settings): ListFilterDropdownElements => {
  const defaultColumnsVisiblity = {
    [ColumnVisibilityValues.RISK_ANALYSIS]: {
      label: ColumnVisibilityLabels.RISK_ANALYSIS,
      checked: true,
      'data-pw': 'columns-visibility-risk-analysis',
    },
    [ColumnVisibilityValues.SENDING]: {
      label: ColumnVisibilityLabels.SENDING,
      checked: true,
      'data-pw': 'columns-visibility-sending',
    },
    [ColumnVisibilityValues.FILE_NAME]: {
      label: ColumnVisibilityLabels.FILE_NAME,
      checked: true,
      'data-pw': 'columns-visibility-file-name',
    },
    [ColumnVisibilityValues.BATCH_NAME]: {
      label: ColumnVisibilityLabels.BATCH_NAME,
      checked: true,
      'data-pw': 'columns-visibility-batch-name',
    },
    [ColumnVisibilityValues.CUSTOMER]: {
      label: ColumnVisibilityLabels.CUSTOMER,
      checked: true,
      'data-pw': 'columns-visibility-customer',
    },
    [ColumnVisibilityValues.DATE]: {
      label: ColumnVisibilityLabels.DATE,
      checked: true,
      'data-pw': 'columns-visibility-date',
    },
    [ColumnVisibilityValues.TEMPLATE_NAME]: {
      label: ColumnVisibilityLabels.TEMPLATE_NAME,
      checked: true,
      'data-pw': 'columns-visibility-template',
    },
    [ColumnVisibilityValues.NUMBER_OF_UPDATES]: {
      label: ColumnVisibilityLabels.NUMBER_OF_UPDATES,
      checked: true,
      'data-pw': 'columns-visibility-number-of-updates',
    },
  };

  if (localStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE.LIST_BATCHES_COLUMNS) !== null) {
    const storedColumnsVisibility: string[] = (localStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE.LIST_BATCHES_COLUMNS) || '').split(',');

    Object.keys(defaultColumnsVisiblity).forEach((key) => {
      defaultColumnsVisiblity[key].checked = storedColumnsVisibility.includes(key);
    });
  }

  return defaultColumnsVisiblity;
};
